import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// 🛡️ Silenciar errores generados por extensiones del navegador (MetaMask, Phantom, etc.)
// que inyectan scripts en cualquier página y disparan el overlay de errores en dev.
// Solo filtramos errores que provienen de chrome-extension:// o menciones a "MetaMask" —
// los errores reales de nuestra app siguen mostrándose.
const _isExtensionError = (msg, source) => {
  const s = String(source || '');
  const m = String(msg || '');
  return s.startsWith('chrome-extension://')
      || s.startsWith('moz-extension://')
      || /MetaMask|inpage\.js|extension:\/\//i.test(m);
};
window.addEventListener('error', (event) => {
  if (_isExtensionError(event.message, event.filename)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = reason?.message || String(reason || '');
  const stack = reason?.stack || '';
  if (_isExtensionError(msg, stack)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
